import { HashLink } from "react-router-hash-link";
import React from 'react'

import "./menu.scss";

const links = [
    { title: "Home", href: "/#Home" },
    { title: "About", href: "/#About" },
    { title: "Projects", href: "/#Projects" },
    { title: "Contacts", href: "/#Contacts" },
]

export default class Menu extends React.Component {
    state = {
        isLinkClicked: false
    }

    clickLink = () => {
        this.setState({ isLinkClicked: !this.state.isLinkClicked });
        this.props.parentCallback(this.state.isLinkClicked);
        document.body.className = '';
    }

    render() {
        const isMenuClosed = this.state.isLinkClicked ? 'closed' : '';

        return (
            <div className={`menu ${isMenuClosed}`}>
                <div className="container">
                    <nav className="menu-nav">
                        {links.map((link) => (
                            <HashLink key={link.title} to={link.href} className="nav-link" >{link.title}
                                <span onClick={this.clickLink}>
                                    {link.title}
                                </span>
                            </HashLink>
                        ))}
                    </nav>
                </div>
            </div>
        )
    }
}